// Sets the browser-tab icon and the iPad/iPhone Home Screen icon to the
// Poppin' West Texas logo. index.html is a Retool platform file we can't edit,
// so the <link> tags are added at startup, replacing any icon Retool put there.
// Safari reads the Home Screen icon when "Add to Home Screen" is tapped.
import { HOME_SCREEN_ICON, TAB_ICON } from './hubIconData'

function setLink(rel: string, href: string, sizes: string) {
  for (const old of Array.from(document.head.querySelectorAll(`link[rel="${rel}"]`))) old.remove()
  const link = document.createElement('link')
  link.rel = rel
  link.type = 'image/png'
  link.href = href
  link.setAttribute('sizes', sizes)
  document.head.appendChild(link)
}

export function setHubIcons() {
  if (typeof document === 'undefined') return
  document.head.querySelectorAll('link[rel="shortcut icon"]').forEach(el => el.remove())
  setLink('icon', TAB_ICON, '64x64')
  setLink('apple-touch-icon', HOME_SCREEN_ICON, '180x180')
}
